import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_select_account = _resolveComponent("select-account")!

  return (_openBlock(), _createBlock(_component_select_account, {
    "parent-id": _ctx.parentId,
    account: _ctx.modelValue,
    stretch: "",
    "onUpdate:account": _cache[0] || (_cache[0] = ($event: any) => {_ctx.$emit('update:modelValue', $event); _ctx.$emit('selected', $event)})
  }, null, 8, ["parent-id", "account"]))
}